"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem"));
var _Box = _interopRequireDefault(require("../../Box"));
var _ListItemAvatar = _interopRequireWildcard(require("../ListItemAvatar"));
var _classnames = _interopRequireDefault(require("./classnames"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var styles = {
  "iconWrapper": "_-0RQ7D",
  "iconDisabled": "Lxrj54",
  "listItemWrapper": "qmWG3m"
};
var ListItem = exports.ListItem = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var avatarProps = _ref.avatarProps,
    button = _ref.button,
    children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    divider = _ref.divider,
    icon = _ref.icon,
    id = _ref.id,
    onClick = _ref.onClick,
    selected = _ref.selected,
    a11yProps = _ref.a11yProps,
    href = _ref.href;
  var a11yItemProps = a11yProps || {};
  var TagType = href && 'a';
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], _extends({
    button: button,
    className: (0, _clsx["default"])(className, _classnames["default"].LIST_ITEM_WRAPPER, styles.listItemWrapper),
    component: TagType,
    href: href,
    "data-testid": dataTestId,
    disabled: disabled,
    divider: divider,
    id: id,
    onClick: onClick,
    selected: selected,
    ref: ref
  }, a11yItemProps), avatarProps && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    mb: 0,
    mr: 2
  }, /*#__PURE__*/_react["default"].createElement(_ListItemAvatar["default"], avatarProps)), icon && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_classnames["default"].LIST_ITEM_ICON_WRAPPER, styles.iconWrapper, disabled && styles.iconDisabled)
  }, icon), children);
});
ListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  avatarProps: _propTypes["default"].shape(_ListItemAvatar.ListItemAvatarPropTypes),
  button: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  divider: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  id: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  selected: _propTypes["default"].bool,
  a11yProps: _propTypes["default"].object,
  href: _propTypes["default"].string
} : {};